import React from "react";
import styles from "./FinalPaymentPage.module.scss";
import className from "classnames/bind";
import usePaymentProcessor from "../../hooks/usePaymentProcessor";
import {
  PaymentStatusMessage,
  OrderSummary,
  CustomerInfo,
  PaymentInfo,
  PaymentActions,
  LoadingSpinner,
  ErrorMessage,
} from "../../components";

const cx = className.bind(styles);

/**
 * FinalPaymentPage Component
 * Displays payment result and order details after checkout completion
 * Supports VNPay, PayPal, and COD payment methods
 */
const FinalPaymentPage = () => {
  const {
    finalOrderData,
    paymentStatus,
    paymentData,
    isLoading,
    error,
  } = usePaymentProcessor();

  const { isPaymentSuccess, isPaymentFailed, isCODOrder } = paymentStatus;

  // Handle loading state
  if (isLoading) {
    return (
      <div className={cx("wrapper")}>
        <div className={cx("container")}>
          <LoadingSpinner 
            message="Loading payment information..." 
            styles={styles} 
          />
        </div>
      </div>
    );
  }

  // Handle error state
  if (error) {
    return (
      <div className={cx("wrapper")}>
        <div className={cx("container")}>
          <ErrorMessage 
            message={error} 
            onRetry={() => window.location.reload()}
            styles={styles}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={cx("wrapper")}>
      <div className={cx("container")}>
        {/* Payment Status Message */}
        <PaymentStatusMessage
          isPaymentSuccess={isPaymentSuccess}
          isPaymentFailed={isPaymentFailed}
          isCODOrder={isCODOrder}
          orderId={paymentData.orderId || finalOrderData?.orderId}
          transactionNo={paymentData.transactionNo}
          styles={styles}
        />

        {/* Order Details */}
        {finalOrderData && (
          <div className={cx("order-details")}>
            <OrderSummary
              items={finalOrderData.items}
              orderData={finalOrderData}
              styles={styles}
            />

            <div className={cx("info-sections")}>
              <CustomerInfo
                customerInfo={finalOrderData.customerInfo}
                styles={styles}
              />

              <PaymentInfo
                paymentInfo={finalOrderData.paymentInfo}
                isPaymentSuccess={isPaymentSuccess}
                isPaymentFailed={isPaymentFailed}
                isCODOrder={isCODOrder}
                styles={styles}
              />
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <PaymentActions
          isPaymentSuccess={isPaymentSuccess}
          isPaymentFailed={isPaymentFailed}
          isCODOrder={isCODOrder}
          styles={styles}
        />
      </div>
    </div>
  );
};

export default FinalPaymentPage;
